import ProjectDefaultProperties from "../default/default-properties"
import projectProperties_toJSON from "../functions/properties-to-json"
import {ProjectAvailableMenuOptions} from "../project-properties"
import ErrorProto from "../../../../gd/validation/error"
import EmbedUtils from "../../../../gd/utils/embed"
import ErrorFieldCustom from "../../../../gd/validation/error-field-custom"
import ProjectSession from "../../project-session"

const DEFAULT = {
    canCreateTask           : false,
    canCreateProject        : false,
    // canCreatePage           : false,
    canCreateLink           : false,
    canCreateEmbed          : false,
    canCreateMeeting        : false,
    canCreateEvent          : false,
    canCreateDiscussion     : false,
    canCreateDocument       : false,
    canCreateGoal           : false,
    canCreateDashboard      : false,
    canCreateRequestForms   : false,
    canCreateAttachments    : false,
}

export default class ProjectLinkProperties extends ProjectDefaultProperties {

    constructor(properties:any, project: ProjectSession) {
        super(properties, project)

        this.canCreateTask                          = DEFAULT.canCreateTask
        this.canCreateProject                       = DEFAULT.canCreateProject
        // this.canCreatePage                          = DEFAULT.canCreatePage
        this.canCreateLink                          = DEFAULT.canCreateLink
        this.canCreateEmbed                         = DEFAULT.canCreateEmbed
        this.canCreateMeeting                       = DEFAULT.canCreateMeeting
        this.canCreateEvent                         = DEFAULT.canCreateEvent
        this.canCreateDiscussion                    = DEFAULT.canCreateDiscussion
        this.canCreateDocument                      = DEFAULT.canCreateDocument
        this.canCreateGoal                          = DEFAULT.canCreateGoal
        this.canCreateDashboard                     = DEFAULT.canCreateDashboard
        this.canCreateRequestForms                  = DEFAULT.canCreateRequestForms
        this.canCreateAttachments                   = DEFAULT.canCreateAttachments
        this.canHaveStatus                          = false

        this.menuSections.customers                 = false
        this.menuSections.reports                   = false
        this.menuSections.integrations              = false
        this.menuSections.automations               = false
        this.menuSections.settings                  = false
    }

    // get onClick() {
    //     if (this.url) {
    //         const isFullLink = this.url.substring(0,4) === 'http'
    //         return () => {
    //             window.open('{0}{1}'.f(isFullLink ? '' : 'https://', this.url))
    //         }
    //     } else {
    //         return () => {
    //             gd.navigation.goToProject(this.project.id, '/link/edit')
    //         }
    //     }
    // }

    get availableMenuOptions(): ProjectAvailableMenuOptions {
        return {
            pinStar         : true,
            info            : true,
            users           : true,
            settings        : false,
            status          : false,
            archive         : false,
            history         : true,
            rename          : true,
            editSource      : true,
            colorIcon       : true,
            move            : true,
            convert         : true,
            duplicate       : true,
            saveAsTemplate  : false,
            delete          : true,
        }
    }

    validate(): ErrorProto[] | null {
        const errors = super.validate() || []

        const embedCode = this.url ? this.url.trim() : ''
        if (embedCode && !EmbedUtils.isLink(embedCode)) {
            errors.push(new ErrorFieldCustom(gd.fields.project.url, {message: 'Value should be a valid URL'}))
        }

        if (_.isEmpty(errors)) return null
        else return errors
    }

    toJSON() {
        return projectProperties_toJSON(this, DEFAULT)
    }
}
